<template>
  <div class="text-left">
    <v-container>
      <v-row>
        <v-col cols="5">
          <v-card class="mx-auto" max-width="344">
            <v-list-item>
              <v-list-item-content>
                <div class="overline">CREATE ADMIN USER</div>
              </v-list-item-content>
            </v-list-item>

            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="mx-4">
                <v-text-field
                  solo
                  label="Name"
                  prepend-inner-icon="people"
                  hide-details="auto"
                  class="mt-1"
                  :rules="[$rules.required]"
                  v-model="form.name"
                ></v-text-field>
                <v-text-field
                  solo
                  label="Email"
                  prepend-inner-icon="email"
                  hide-details="auto"
                  class="mt-1"
                  :rules="[$rules.required, $rules.email]"
                  v-model="form.email"
                ></v-text-field>
                <v-select
                  solo
                  :items="rolesArray"
                  label="Role"
                  prepend-inner-icon="people"
                  hide-details="auto"
                  class="mt-1"
                  :rules="[$rules.required]"
                  v-model="form.role"
                ></v-select>
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!valid" @click="createUser"
                  >Create</v-btn
                >
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
        <v-col cols="7">
          <v-card class="pb-4">
            <v-list-item>
              <v-list-item-content>
                <div class="overline">EXISTING ADMIN USERS</div>
              </v-list-item-content>
            </v-list-item>

            <v-list three-line>
              <template v-for="(item, id, index) in dbAdminUsers">
                <v-list-item
                  :key="id"
                  :class="{
                    'indigo lighten-5':
                      !item.deleted && adminUser.email === item.email,
                    'red lighten-5': item.deleted
                  }"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="item.deleted ? 'grey--text' : 'primary--text'"
                      ><v-icon v-if="item.deleted" color="grey" dense
                        >mdi-delete</v-icon
                      >{{ item.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text--primary">{{
                      $roles[item.role]
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-text="item.email"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text>
                      <template v-if="item.lastSeen">
                        active {{ item.lastSeen | moment("from") }}
                      </template>
                      <v-menu bottom left>
                        <template v-slot:activator="{ on }">
                          <v-btn color="grey" icon v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>

                        <v-list class="text-left">
                          <v-list-item
                            @click="sendResetPasswordEmail(item.email)"
                            v-if="!item.deleted"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                >Send reset password email</v-list-item-title
                              >
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon>mdi-email</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-list-item @click="updateAdminUser(id, item.name)">
                            <v-list-item-content>
                              <v-list-item-title>Edit</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-list-item
                            @click="deleteAdminUser(id, item.email)"
                            v-if="!item.deleted"
                          >
                            <v-list-item-content>
                              <v-list-item-title>Delete user</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon color="error">mdi-delete</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>

                <v-divider :key="'divider-' + index"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="showDialog" max-width="400">
      <v-card class="pa-4">
        <v-card-title class="headline">Edit User</v-card-title>

        <v-card-text>
          <v-text-field
            v-model="editUserName"
            label="Name"
            outlined
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" @click="saveAdminUser">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AdminUsers",
  data: () => ({
    form: {
      role: null,
      email: null,
      name: null
    },
    valid: true,
    showDialog: false,
    editUserId: null,
    editUserName: null
  }),
  computed: {
    ...mapState(["userRole", "adminUser", "dbAdminUsers"]),
    rolesArray: function() {
      return Object.keys(this.$roles).map(value => {
        if (value === "admin" && this.userRole !== "admin") {
          return { value, text: this.$roles[value], disabled: true };
        }
        return { value, text: this.$roles[value] };
      });
    }
  },
  methods: {
    createUser() {
      if (this.$refs.form.validate()) {
        const { role, email, name } = this.form;

        let adminUser = {
          email: email,
          name: name,
          role: role
        };

        this.$store.dispatch("pushAdminUser", adminUser);

        setTimeout(() => {
          this.$store.dispatch("sendResetPasswordEmail", email);
        }, 1000 * 5);
      }
    },
    sendResetPasswordEmail(email) {
      this.$store.dispatch("sendResetPasswordEmail", email);
    },
    deleteAdminUser(uid, email) {
      this.$store.dispatch("deleteAdminUser", { uid, email });
    },
    updateAdminUser(id, name) {
      this.editUserId = id;
      this.editUserName = name;
      this.showDialog = true;
    },
    saveAdminUser() {
      this.$store.dispatch("updateAdminUser", {
        id: this.editUserId,
        name: this.editUserName
      });

      this.editUserId = null;
      this.editUserName = null;
      this.showDialog = false;
    }
  }
};
</script>
